
import { useState } from 'react';

/**
 * Número de WhatsApp en formato internacional sin símbolos.
 * Se mantiene como cadena para evitar que el linter lo interprete como número.
 */
const WHATSAPP_NUMBER = '18094619001';

/**
 * Mensaje por defecto que se enviará al abrir el enlace.
 * Se codifica con `encodeURIComponent` antes de insertarlo en la URL.
 */
const WHATSAPP_MESSAGE =
  '¡Hola! Me interesa obtener información sobre los tours y traslados de Leury Tours.';

/**
 * Botón flotante que abre una conversación de WhatsApp en una nueva pestaña.
 *
 * - Cambia su padding y muestra el texto "WhatsApp" al pasar el ratón.
 * - Se añaden comprobaciones de disponibilidad de `window` para evitar errores en entornos
 *   de renderizado del lado del servidor (SSR).
 * - Se maneja cualquier error inesperado al intentar abrir la URL.
 */
const WhatsAppButton = () => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    try {
      // Mensaje predeterminado para WhatsApp
      const message = encodeURIComponent(
        "Hello! I'm interested in getting information about Leury Tours' tours and transportation services. Could you please provide more details? Thank you!"
      );

      // Construimos la URL de forma segura
      const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;

      // `window` solo está disponible en el cliente; comprobamos antes de usarlo
      if (typeof window !== 'undefined' && window.open) {
        window.open(url, '_blank', 'noopener,noreferrer');
      } else {
        console.warn('window.open is not available. Unable to open WhatsApp link.');
      }
    } catch (error) {
      // Capturamos cualquier error inesperado y lo registramos para depuración
      console.error('Error opening WhatsApp link:', error);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label="Contactar por WhatsApp"
      className="fixed bottom-24 right-6 z-50 flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5b] text-white rounded-full shadow-lg cursor-pointer transition-all duration-300 whitespace-nowrap"
      style={{
        // Padding más amplio cuando se muestra el texto para mantener la forma redonda
        padding: isHovered ? '12px 20px' : '14px',
      }}
    >
      <span className="w-7 h-7 flex items-center justify-center text-2xl">
        <i className="ri-whatsapp-line" aria-hidden="true"></i>
      </span>
      {isHovered && (
        <span className="text-sm font-medium pr-1 animate-fade-in">WhatsApp</span>
      )}
    </button>
  );
};

export default WhatsAppButton;
